export interface CategoryEntry {
  key: string;
  label: string;
  icon: string;
  color: "primary" | "accent" | "secondary";
}

export const homeCategories: CategoryEntry[] = [
  { key: "movie", label: "电影", icon: "ri-film-line", color: "primary" },
  { key: "tv", label: "电视剧", icon: "ri-tv-2-line", color: "accent" },
  { key: "action", label: "动作", icon: "ri-fire-line", color: "secondary" },
  { key: "romance", label: "爱情", icon: "ri-heart-3-line", color: "accent" },
  { key: "scifi", label: "科幻", icon: "ri-planet-line", color: "primary" },
  { key: "china", label: "国产", icon: "ri-flag-2-line", color: "secondary" },
  { key: "hollywood", label: "欧美", icon: "ri-earth-line", color: "primary" },
  { key: "suspense", label: "悬疑", icon: "ri-eye-line", color: "accent" },
];